import { createThemeCompiler } from '../../../utils';

export const calendarThemeCompiler = createThemeCompiler(({ palette }) => ({
    calendar: {
        colors: {
            defaultDate: {
                backgroundColor: palette.white,
                foregroundColor: palette.neutralPrimary
            },
            otherMonthDate: {
                backgroundColor: palette.white,
                foregroundColor: palette.neutralSecondaryAlt
            },
            currentDate: {
                backgroundColor: palette.themePrimary,
                foregroundColor: palette.themePrimary
            },
            selectedDate: {
                backgroundColor: palette.themePrimary,
                foregroundColor: palette.white
            },
            dateRange: {
                backgroundColor: palette.themeLighterAlt,
                foregroundColor: palette.neutralPrimary
            },
            hover: {
                backgroundColor: palette.themeLighterAlt,
                foregroundColor: palette.themePrimary
            },
            disabled: {
                backgroundColor: palette.neutralQuaternary,
                foregroundColor: palette.neutralSecondaryAlt
            },
            disabledHover: {
                backgroundColor: palette.neutralQuaternary,
                foregroundColor: palette.neutralSecondaryAlt
            },
            otherMonthDateHover: {
                backgroundColor: palette.themeLighterAlt,
                foregroundColor: palette.themePrimary
            },
            selectedDateHover: {
                backgroundColor: palette.themePrimary,
                foregroundColor: palette.white
            }
        },
        composites: {
        }
    }
}));
